import React, { useState, useEffect } from 'react'
import { Select } from 'antd'
import { getDischems } from '../../Scripting/utils/utils'

const { Option } = Select

const DischemStoreSelector = ({ value, onChange, disabled = false }) => {
  const [stores, setStores] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchStores()
  }, [])

  const fetchStores = async () => {
    setLoading(true)
    try {
      const storeData = await getDischems()
      setStores(storeData || [])
    } catch (error) {
      console.error('Error fetching Dis-Chem stores:', error)
      setStores([])
    } finally {
      setLoading(false)
    }
  }

  const handleStoreChange = (selectedValue) => {
    if (!selectedValue) {
      onChange(null)
      return
    }

    const fullStoreData = JSON.parse(selectedValue)

    // Only store name and placeId as per booking schema
    const storeForBooking = {
      name: fullStoreData.name,
      placeId: fullStoreData.placeId || fullStoreData.place_id || fullStoreData.id || fullStoreData._id
    }

    onChange(storeForBooking)
  }

  // Get the dropdown value for the currently selected store
  const getDropdownValue = () => {
    if (!value?.placeId) return undefined

    const fullStore = stores.find(
      (store) =>
        store.placeId === value.placeId ||
        store.place_id === value.placeId ||
        store.id === value.placeId ||
        store._id === value.placeId ||
        store.name === value.name
    )

    return fullStore ? JSON.stringify(fullStore) : undefined
  }

  return (
    <Select
      placeholder='Select a Dis-Chem store...'
      value={getDropdownValue()}
      onChange={handleStoreChange}
      loading={loading}
      disabled={disabled}
      style={{ width: '100%' }}
      size='large'
      showSearch
      filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
    >
      {stores.map((store) => (
        <Option key={store._id || store.id} value={JSON.stringify(store)}>
          {store.name}
        </Option>
      ))}
    </Select>
  )
}

export default DischemStoreSelector
